import React from 'react'
import { WMSTileLayer } from 'react-leaflet'

const SERFOR_MODALIDAD_ACCESO_WMS_URL =
  'https://geo.serfor.gob.pe/geoservicios/services/Servicios_OGC/Modalidad_Acceso/MapServer/WmsServer'

export const SERFOR_MODALIDAD_ACCESO_LEGENDS = [
  { layer: 0, label: 'Forest concessions' },
  { layer: 1, label: 'Harvesting unit' },
  { layer: 2, label: 'Local forests' },
  { layer: 3, label: 'Agricultural land-use-change authorisations' },
  { layer: 4, label: 'PFDM authorisations in AVNB' },
  { layer: 5, label: 'Use assignments' },
  { layer: 6, label: 'Permits' },
].map(({ layer, label }) => ({
  label,
  url: `${SERFOR_MODALIDAD_ACCESO_WMS_URL}?request=GetLegendGraphic&version=1.1.1&format=image/png&layer=${layer}`,
}))

function PeruModalidadesAccesoForestalLayer({ opacity = 0.6 }) {
  return (
    <WMSTileLayer
      layers="0,1,2,3,4,5,6"
      styles=""
      format="image/png"
      version="1.1.1"
      transparent
      url={SERFOR_MODALIDAD_ACCESO_WMS_URL}
      opacity={opacity}
    />
  )
}

export default PeruModalidadesAccesoForestalLayer
